import React from 'react';
import styled from 'styled-components';
import DashboardEngTitle from '../../Molecule/Card/CardEngTitle/DashboardTitle';
import DashboardKorTitle from '../../Molecule/Card/CardKorTitle/DashboardTitle';
import LineChart from '../../Molecule/Chart/LineChart';
import RateCount from '../../Molecule/Count/RateCount';
import TimeCount from '../../Molecule/Count/TimeCount';
import ValueCount from '../../Molecule/Count/ValueCount';
import Spinner from '../../Molecule/Spinner';

const Component = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 488px;
  background-color: white;
  border-radius: 16px;
  padding: 24px 24px 40px;

  .voda_dashboard_eng_title {
    margin-bottom: 8px;
  }

  .voda_dashboard_kor_title {
    margin-bottom: 24px;
  }

  .voda_line_chart {
    margin-bottom: 40px;
  }
`;

const CountWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface DashboardLineCardProps {
  titleEng: string;
  titleKor: string;

  lineChartName: string;
  option: string;
  isTimeCount: boolean;
  isLoading: boolean;
  data?: {
    [key: string]: number;
  };
  value?: number;
  rate?: number;
  time?: number;
}

const DashboardLineCard = ({
  titleEng,
  titleKor,
  lineChartName,
  option,
  isTimeCount,
  isLoading,
  data,
  value,
  rate,
  time,
}: DashboardLineCardProps) => {
  return (
    <Component>
      <DashboardEngTitle title={titleEng} />
      <DashboardKorTitle title={titleKor} />
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <LineChart
            name={lineChartName}
            option={option}
            isTimeCount={isTimeCount}
            data={data}
          />
          <CountWrapper>
            {isTimeCount ? (
              <TimeCount time={time} />
            ) : (
              <ValueCount value={value} />
            )}
            <RateCount rate={rate} />
          </CountWrapper>
        </>
      )}
    </Component>
  );
};
export default DashboardLineCard;
